<div class="step-address">
  <h2 class="step-title">Domicilio del cliente</h2>

  @if (clientAddresses.length) {
    <div class="saved-addresses">
      <h3 class="subtitle">Domicilios guardados</h3>
      <div class="address-grid">
        @for (address of clientAddresses; track address; let i = $index) {
          <div
            class="addressCard"
            [ngClass]="{ selectedAddress: selectedAddressId == address.id }"
            (click)="selectAddress(address)"
            (keydown)="onRowKeydown($event, i)"
            >
            <mat-icon aria-hidden="true">
              {{
              selectedAddressId == address.id
              ? "check_circle"
              : "radio_button_unchecked"
              }}
            </mat-icon>
            <span class="addressCard__text">
              <span class="addressCard__title">{{ address.street }} {{ address.number }}</span>
              @if (address.locationSummary) {
                <span class="addressCard__meta">{{ address.locationSummary.description }}</span>
              }
            </span>
          </div>
        }
      </div>
    </div>
  }
  <form [formGroup]="workloadForm">
    <div class="address-header">
      <h3 class="section-title">Domicilio</h3>
    </div>
    <div class="address-body">
      <div class="address-body__form">
        <app-address [form]="workloadForm" alias="legalAddress"></app-address>
      </div>
      <div class="address-body__map">
        <div class="address-body__map-action">
          <button
            type="button"
            class="map-link"
            (click)="addPointerMarker()"
            [disabled]="disableCoordinates"
            >
            <mat-icon>place</mat-icon> Buscar ubicación en el mapa
          </button>
        </div>
        <div class="address-body__map-canvas">
          <indu-map
            [markers]="disableCoordinates ? [] : markers"
            [center]="center"
            [zoom]="17"
            [draggable]="true"
            (markerDragendEvent)="markerDragend(0, $event)"
            >
          </indu-map>
        </div>
      </div>
    </div>
  </form>
</div>
